import { ApkInfoDto } from '../../shared/dtos/apk-info.dto';
import { ApkInfoModel } from '../../shared/models/apk-info.model';
import { mapPlatformModelToPlatformDto } from '../../shared/utils/mapping/mapping.utils';
import { AppResponseMinimalDto } from '../dtos/app-response-minimal.dto';
import { AppResponseMinimalModel } from '../models/app-response-minimal.model';

export const mapExceptedAppsDtoToExceptedAppsModel = ({
  id,
  name,
}: AppResponseMinimalDto): AppResponseMinimalModel => ({ id, name });

export const mapApkInfoModelToApkInfoDto = ({
  platforms,
  versionCode,
  versionName,
  androidMinSDKVersion,
  androidMaxSDKVersion,
  androidPackage,
}: ApkInfoModel): ApkInfoDto => ({
  androidMinSDKVersion,
  androidMaxSDKVersion,
  androidPackage,
  versionName,
  versionCode,
  platforms: platforms.map(mapPlatformModelToPlatformDto),
});
